import surveyReducer from './survey';

export default {
    surveyReducer,
};
